import { render } from "./ClientAddressCard.vue?vue&type=template&id=0ce85a2b"
import script from "./ClientAddressCard.vue?vue&type=script&lang=js"
export * from "./ClientAddressCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__